const common = {
  siteName: 'Reserve Connect Urubici',
  tagline: 'Hospedagens na Serra Catarinense',
  loading: 'Carregando...',
  error: 'Erro ao carregar',
  retry: 'Tentar novamente',
  back: 'Voltar',
  search: 'Buscar',
  filter: 'Filtrar',
  bookNow: 'Reservar Agora',
  contactUs: 'Fale Conosco',
  whatsapp: 'WhatsApp',
  phone: 'Telefone',
  email: 'E-mail',
  navigation: {
    home: 'Início',
    lodging: 'Hospedagens',
    restaurants: 'Restaurantes',
    experiences: 'Experiências',
    events: 'Eventos',
    cityGuide: 'Onde Ir',
    about: 'Sobre',
    contact: 'Contato',
    groups: 'Grupos e Agências',
    terms: 'Termos de Uso',
    privacy: 'Política de Privacidade',
    cookies: 'Política de Cookies',
    cancellation: 'Cancelamento e Reembolso',
    login: 'Login',
    centralReservas: 'Central de Reservas',
    announcers: 'Para Anunciantes',
  },
  header: {
    language: 'Idioma:',
    menuAriaLabel: 'Abrir menu',
  },
  footer: {
    brand: 'Reserve Connect',
    institutional: 'Institucional',
    services: 'Serviços',
    legal: 'Legal',
    rights: 'Todos os direitos reservados.',
    description: 'Plataforma de reservas integrada para conectar turistas aos melhores hotéis e experiências locais.',
    whatsappContact: 'Falar com a Central no WhatsApp',
    whatsappMessage: 'Olá! Gostaria de ajuda com uma reserva.',
    poweredBy: 'Powered by Readdy',
    links: {
      aboutUs: 'Sobre o Reserve Connect',
      forHotels: 'Para Hotéis',
      municipalIntegration: 'Integração Municipal',
      cityPortal: 'Portal da Cidade',
      hotels: 'Hotéis',
      support: 'Suporte',
      faq: 'FAQ',
    },
  },
  aria: {
    previousSlide: 'Slide anterior',
    nextSlide: 'Próximo slide',
    goToSlide: 'Ir para slide {{number}}',
    switchLanguage: 'Mudar idioma para {{lang}}',
  },
};
export default common;
